/* global yaCounter55098703 */

import scrollDepth from 'scroll-depth';
import vars from '../globals';

let videoInterval;

export const spent15sec = () => {
	ga('rbcspec.send', 'event', 'page', 'spent_on_page_15_sec');
	ga('send', 'event', 'page', 'spent_on_page_15_sec');
};

export const hit = (path) => {
	ga('set', 'page', path);
	ga('send', 'pageview', path);

	ga('rbcspec.set', 'page', path);
	ga('rbcspec.send', 'pageview', path);

	if (window.yaCounter55098703) {
		yaCounter55098703.hit(path);
	}
};

scrollDepth({
	userTiming: false,
	pixelDepth: false,
	gtmOverride: true,
	eventHandler(data) {
		ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: true});
		ga('rbcspec.send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: true});
	},
});

$('.header__link--rbc').on('click', () => {
	ga('send', 'event', 'nav', 'rbc logo');
});

$('.header__link--huawei').on('click', () => {
	ga('send', 'event', 'client link', 'logo header');
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$('.hero__play-button').on('click', () => {
	ga('send', 'event', 'main', 'go to test');
});

$('.product__button').on('click', (e) => {
	let name = $(e.currentTarget).prev().text();

	ga('send', 'event', 'main', 'go to product page', name);
});

$('.lifehack').on('click', (e) => {
	let name = $(e.currentTarget).find('h3').text();

	ga('send', 'event', 'main', 'go to advice page', name);
});

vars.$document.on('test-start', () => {
	ga('send', 'event', 'test', 'start', {nonInteraction: true});
});

$('.test-video').on('play', (e) => {
	let num = $(e.currentTarget).closest('.test__step').data('number');

	ga('send', 'event', 'test', `start video ${num}`, {nonInteraction: true});
});

$('.test-video').on('ended', (e) => {
	let num = $(e.currentTarget).closest('.test__step').data('number');

	ga('send', 'event', 'test', `finish video ${num}`);
});

$('.test-video').on('volumechange', () => {
	ga('send', 'event', 'nav', 'mute');
});

$('.test-video__skip-button').on('click', (e) => {
	let num = $(e.currentTarget).closest('.test__step').data('number');

	ga('send', 'event', 'test', `skip video ${num}`);
});

$('.test-video__container').on('test-show-question', (e) => {
	let num = $(e.currentTarget).closest('.test__step').data('number');
	let name = $(e.currentTarget).closest('.test__step').find('.test__question').text();

	ga('send', 'event', 'test', `question show ${num}`, name);
});

$('.test__checkbox').on('change', (e) => {
	let num = $(e.currentTarget).closest('.test__step').data('number');
	let name = $(e.currentTarget).closest('.test__variant').find('.test__variant-description').text();

	ga('send', 'event', 'test', `question answer ${num}`, `${name}`);
});

$('.test__button').on('click', (e) => {
	let num = $(e.currentTarget).closest('.test__step').data('number');

	ga('send', 'event', 'test', 'next button click', `${num}`);
});

export const testFinished = () => {
	let result = $('.test-result__mark').text();

	ga('send', 'event', 'test', 'finish', result);
};

$('.test-result__button').on('click', () => {
	ga('send', 'event', 'test', 'resume');
});

$('.result .social').on('click', (e) => {
	let name = $(e.currentTarget).data('social');

	ga('send', 'event', 'share', 'test result share', name);
});

$('.result').on('click', '.related__slide a', (e) => {
	let name = $(e.currentTarget).text();

	ga('send', 'event', 'test', 'go to advice page', name);
});

$('.video-container').on('play', (e) => {
	let name;

	if ($(e.currentTarget).closest('.test')) {
		let num = $(e.currentTarget).closest('.test__step').data('number');

		name = `Тест || ${num}`;
	} else {
		name = $(e.currentTarget).parent('.page').find('.video-title').text();
	}

	ga('send', 'event', 'video', 'play', name, {nonInteraction: true});
	ga('rbcspec.send', 'event', 'video', 'play', {nonInteraction: true});

	videoInterval = setInterval(() => {
		ga('send', 'event', 'video', 'timing 5s', name, 5);
		ga('rbcspec.send', 'event', 'video', 'timing 5s', '', 5);
	}, 5000);
});

$('.video-container').on('ended', (e) => {
	let name;

	if ($(e.currentTarget).closest('.test')) {
		let num = $(e.currentTarget).closest('.test__step').data('number');

		name = `Тест || ${num}`;
	} else {
		name = $(e.currentTarget).parent('.page').find('.video-title').text();
	}

	ga('send', 'event', 'video', 'finish', name);
	ga('rbcspec.send', 'event', 'video', 'finish');

	clearInterval(videoInterval);
});

$('.video-container').on('pause', () => {
	clearInterval(videoInterval);
});

$('.navigation__link').on('click', () => {
	ga('send', 'event', 'advice', 'change advice click');
});

$('.product-cart').on('click', (e) => {
	let name = $(e.currentTarget).find('.product-cart__title').text();

	ga('send', 'event', 'client link', 'advice first tizer', name);
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$('.article__banner-link').on('click', (e) => {
	let name = $(e.currentTarget).closest('.page').find('.product-cart__title').text();

	ga('send', 'event', 'client link', 'advice second tizer', name);
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$('.article__block a').on('click', (e) => {
	let name = $(e.currentTarget).attr('href');

	ga('send', 'event', 'advice', 'text link', name);
});

$('.article').on('click', '.related__slide-text', (e) => {
	let name = $(e.currentTarget).text();

	ga('send', 'event', 'advice', 'see also', name);
});

$('.product-block__button').on('click', (e) => {
	let name = $(e.currentTarget).closest('.product-block').find('.product-block__title').text();

	ga('send', 'event', 'client link', 'product buy button', name);
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$('.footer .social').on('click', (e) => {
	let name = $(e.currentTarget).data('social');

	ga('send', 'event', 'share', 'project footer share', name);
});

$('.article__share .social').on('click', (e) => {
	let name = $(e.currentTarget).data('social');

	ga('send', 'event', 'share', 'advice share', name);
});

// video

vars.$document
	.on('video-start', (e, name) => {
		ga('send', 'event', 'video', 'play', name, {nonInteraction: true});
		ga('rbcspec.send', 'event', 'video', 'play', {nonInteraction: true});
	})
	.on('video-5sec', (e, name) => {
		ga('send', 'event', 'video', 'timing 5s', name, 5);
		ga('rbcspec.send', 'event', 'video', 'timing 5s', '', 5);
	})
	.on('video-end', (e, name) => {
		ga('send', 'event', 'video', 'finish', name);
		ga('rbcspec.send', 'event', 'video', 'finish');
	});
